import React, { useRef, useState } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import styles from './styles.module.scss';
import Lightbox from './Lightbox';
import { getFotoProductoUrl } from '../../utils/utils';
import { StrapiMediaCollection } from '../../models/Strapi';

type CarouselDeFotosProps = {
    data?: StrapiMediaCollection['data']
    badge?: string
}

const CarouselDeFotos = ({ data, badge }: CarouselDeFotosProps) => {

  const fotos = data || [];
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const mainSwiperRef = useRef<any>(null);

  const handleCloseLightbox = (index: number) => {
    setLightboxOpen(false);
    mainSwiperRef.current?.slideToLoop(index, 0);
  };

  return (<>
    <div className={styles.contenedor}>

      <div className={styles.marco}>
        {badge && <div className={styles.cucarda}>{badge}</div>}

        <Swiper
          onSwiper={(swiper) => { mainSwiperRef.current = swiper; }}
          thumbs={{ swiper: thumbsSwiper }}
          modules={[Navigation, Thumbs]}
          spaceBetween={0}
          slidesPerView={1}
          loop={fotos.length > 1}
          navigation={fotos.length > 1}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        >
          {fotos.map((item) => (
            <SwiperSlide key={item.id} onClick={() => setLightboxOpen(true)}>
              <Image
                className={styles.img}
                src={getFotoProductoUrl(item) || 'https://dummyimage.com/558x702/000000/ffffff'}
                alt={item.attributes.alternativeText || 'We Celebrate'}
                fill
                sizes="(max-width: 900px) 100vw, 500px"
                priority
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className={styles.zoomHint} onClick={() => setLightboxOpen(true)}>
          <ZoomInIcon fontSize="small" />
        </div>
      </div>

      {fotos.length > 1 &&
        <Swiper
          className={styles.thumbs}
          onSwiper={setThumbsSwiper}
          observer={true}
          observeParents={true}
          loop={false}
          loopedSlides={1}
          spaceBetween={10}
          slidesPerView={4}
          watchSlidesProgress={true}
        >
          {fotos.map((item) => (
            <SwiperSlide key={item.id}>
              <div className={styles.thumbFrame}>
                <Image
                  className={styles.thumbImg}
                  src={item.attributes.formats?.thumbnail?.url || item.attributes.url}
                  alt={item.attributes.alternativeText || 'We Celebrate'}
                  width={140}
                  height={140}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      }
    </div>

    <Lightbox
      open={lightboxOpen}
      fotos={fotos}
      initialIndex={activeIndex}
      onClose={handleCloseLightbox}
    />
  </>);
};

export default CarouselDeFotos;
